import { Callout } from "@octopusdeploy/design-system-components";
import { Permission } from "@octopusdeploy/octopus-server-client";
import type { BuiltInFeedResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import type { FC } from "react";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import PermissionCheck from "~/components/PermissionCheck/PermissionCheck";
import EditBuiltInRepositoryRetention from "./EditBuiltInRepositoryRetention";
interface BuiltInRepositoryRetentionProps {
    config: BuiltInFeedResource;
    afterConfigurationUpdated(config: BuiltInFeedResource): void;
}
const BuiltInRepositoryRetention: FC<BuiltInRepositoryRetentionProps> = (props) => {
    const retainIndefinitely = (<p>
            Packages stored in the repository will be <strong>retained indefinitely</strong>
        </p>);
    const retainForDays = (<div>
            <p>
                {isFeatureToggleEnabled("DecoupleReleasesFromBuiltInPackageRetentionFeatureToggle") && props.config.DeletePackagesAssociatedWithReleases
            ? "Packages not used in a release or runbook run on the dashboard "
            : "Packages not used in a release or runbook run "}
                will be automatically deleted from the repository after <strong>{props.config.DeleteUnreleasedPackagesAfterDays}</strong> days.
            </p>
            <p>
                {isFeatureToggleEnabled("DecoupleReleasesFromBuiltInPackageRetentionFeatureToggle") && props.config.DeletePackagesAssociatedWithReleases
            ? "Packages used in a current or previous release on the dashboard will not be deleted unless the release is deleted."
            : "Packages used in a release or runbook run will not be deleted unless the release is deleted."}
            </p>
        </div>);
    const getSummary = () => {
        if (props.config && props.config.DeleteUnreleasedPackagesAfterDays) {
            return retainForDays;
        }
        else {
            return retainIndefinitely;
        }
    };
    return (<div>
            <h4>Repository Retention</h4>
            <PermissionCheck permission={Permission.ConfigureServer} alternate={<Callout type={"information"} title={"Permission required"}>
                        The {Permission.ConfigureServer} permission is required to view and change the repository retention settings
                    </Callout>}>
                <div>
                    {getSummary()}
                    <OpenDialogButton label="Change">
                        <EditBuiltInRepositoryRetention afterConfigurationUpdated={props.afterConfigurationUpdated}/>
                    </OpenDialogButton>
                </div>
            </PermissionCheck>
        </div>);
};
BuiltInRepositoryRetention.displayName = "BuiltInRepositoryRetention";
export default BuiltInRepositoryRetention;
